export default __webpack_public_path__ + "static/media/docs-burnout-buttery-man.21d06b5f.png";